module.exports = __webpack_public_path__ + "static/media/fashion & beauty.55bcf4e5.png";